import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { ToggleRegs } from '@studio/types';

export const root = {
  [HTTP_METHODS.PUT]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/users/@id/toggleregs`,
    request: {} as ToggleRegs.Put.Toggles,
    params: {} as { id: string },
    method: HTTP_METHODS.PUT,
  },
};
